import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import startsWith from 'lodash/startsWith';
import get from 'lodash/get';
import { useLocationPageNames } from 'modules/core';
import { NavBar, NavBarLink } from 'modules/ui';
import {
  AccountAvatarMenu,
  AccountNavBarEnvelope,
  AGENT_PAGES,
} from 'modules/accounts';
import { getAgent } from '../redux';

function AgentNavBar({ avatar, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPageName = useLocationPageNames(AGENT_PAGES.PAGES);
  const agent = useSelector(getAgent);

  const fullName = get(agent, 'fullName');
  const city = get(agent, 'city');
  const state = get(agent, 'state.name');
  const country = get(agent, 'country.name');

  function handleEditProfileClick() {
    navigate('/profile/edit');
  }

  function handleSettingsClick() {
    navigate('/settings/change-password');
  }

  function handleProfileClick() {
    navigate('/profile');
  }

  return (
    <NavBar
      activePageName={currentPageName}
      rightIconComponent={<AccountNavBarEnvelope />}
      showMobile={false}
      className="pt-4"
    >
      <NavBarLink
        to="/"
        isExtraUrlMatch={
          location.pathname === '/' || startsWith(location.pathname, '/clients')
        }
        id="clients-link"
      >
        My Clients
      </NavBarLink>
      <NavBarLink to="/auditions" id="auditions-link">
        Auditions
      </NavBarLink>
      <NavBarLink to="/offers" id="offers-link">
        Offers
      </NavBarLink>
      <NavBarLink to="/lists" id="lists-link">
        Lists
      </NavBarLink>
      <AccountNavBarEnvelope />
      <AccountAvatarMenu
        avatar={avatar}
        fullName={fullName}
        city={city}
        state={state}
        country={country}
        onProfile={handleProfileClick}
        onLogout={onLogout}
        onEditProfile={handleEditProfileClick}
        onSettings={handleSettingsClick}
        isActive={startsWith(location.pathname, '/profile')}
        enableHoverBorder
      />
    </NavBar>
  );
}

AgentNavBar.propTypes = {
  avatar: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};

export default AgentNavBar;
